export default __webpack_public_path__ + "static/media/Compare-white.0dd56850.svg";